import React from "react";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  CircularProgress,
  Container,
} from "@mui/material";
import { Stack } from "@mui/system";

type Props = {
  isOpen: boolean;
  handleClose?: () => void;
  onYes?: () => void;
  onNo?: () => void;
  title?: string;
  content?: string;
  yesText?: string;
  noText?: string;
  isLoading?: boolean;
};

export const CustomDialog: React.FC<Props> = ({
  isOpen,
  handleClose,
  onYes,
  onNo,
  title,
  content,
  yesText = "Ok",
  noText = "Cancelar",
  isLoading = false,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <Stack direction="row">
        {onNo && !isLoading && (
          <DialogActions>
            <Button onClick={onNo} autoFocus>
              {noText}
            </Button>
          </DialogActions>
        )}
        {!isLoading && (
          <DialogActions>
            <Button onClick={onYes ? onYes : handleClose} autoFocus>
              {yesText}
            </Button>
          </DialogActions>
        )}
        {isLoading && (
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <CircularProgress />
          </DialogActions>
        )}
      </Stack>
    </Dialog>
  );
};
